import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ProductRuntime } from '@ilabel/platform-core';
import { vlaProductConfig } from '@ilabel/product-config';
import { TeamMembersRuntime } from '@ilabel/team-members/runtime';
import { UiProvider } from '@ilabel/ui';

import '@ilabel/team-members/styles.css';
import '@ilabel/ui/styles.css';
import { App } from './app/app.js';
import { api } from './lib/api-client.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: false },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ProductRuntime config={vlaProductConfig}>
    <TeamMembersRuntime request={api}>
      <QueryClientProvider client={queryClient}>
        <UiProvider><App /></UiProvider>
      </QueryClientProvider>
    </TeamMembersRuntime>
  </ProductRuntime>,
);
